import vex from "vex-js";
import vexDialog from "vex-dialog";

vex.registerPlugin(vexDialog);

export default vex;
